// Vendor
import React from "react";
import { Trans } from "@coworker/locales";
// Enums
import {
  REPEATABLE_WIDGET,
  SCHEDULE_WIDGET,
  CUSTOM_TITLE_WIDGET,
  PRIORITY_WIDGET,
  ASSIGN_WIDGET,
  OPTIONAL_LOCATION_WIDGET,
  PHOTOS_WIDGET,
} from "./_common";
import { DESCRIPTION } from "../widgets";
import NoteIcon from "../../../assets/svg/Note.svg?react";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";

export default {
  table: "tasks",
  type: "custom",
  enumType: TaskType.CUSTOM,
  validate: (form) => {
    const potentialInvalids = [
      !form.assigned_team_id,
      !form.custom_title,
      !form.description,
      form.images?.some((image) => image.loading),
    ];
    return !potentialInvalids.reduce((invalid, curr) => invalid || curr, false);
  },
  fieldsFilledCount: (form) => {
    let count = 0;
    if (form.custom_title) count++;
    if (form.description) count++;
    if (form.assigned_team_id) count++;
    if (form.priority_flag) count++;
    if (form.location_custom) count++;
    if (form.planned) count++;
    if (form.images && form.images.length > 0) count++; // Do not care if the image is loading. User has interacted with the field if length > 0
    return count;
  },
  header: {
    newTitle: <Trans>customString</Trans>,
    editTitle: <Trans>editTaskString</Trans>,
    testId: "headerTitle",
  },
  fields: [
    CUSTOM_TITLE_WIDGET,
    {
      type: DESCRIPTION,
      conf: {
        icon: <NoteIcon />,
        lblColor: "var(--grey900)",
        overridePadding: "0px 16px 0px 24px",
      },
      values: {
        in: ({ description }) => description,
        out: (description) => ({ description }),
      },
    },
    ASSIGN_WIDGET,
    PRIORITY_WIDGET,
    OPTIONAL_LOCATION_WIDGET,
    REPEATABLE_WIDGET,
    SCHEDULE_WIDGET,
    PHOTOS_WIDGET,
  ],
};
